import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ThrowStmt } from '@angular/compiler';
// import { link } from 'fs';

@Injectable({
  providedIn: 'root'
})
export class RaghuserviceService {

  constructor(private http:HttpClient) { }

  readRaghuApi(){
    return this.http.get('assets/data/sloka.json')
  }

  
  readAnalysis(){
    return this.http.get('assets/data/analysis.json')
  }

  apilinks : any = []
  samAsaLink : any
  createGraph(input:any, apiLink:any){
    return this.http.get(apiLink+'/dotapi/createDot.php?input='+input, {responseType: 'text'} )
  }

  getDict(stem:any){
    return this.http.get('https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word='+stem+'&outencoding=DEV', {responseType:'text'})
  }

}
